import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine
} from 'recharts';


class ChartLine extends PureComponent {

    // TODO:
    // GOAL!

    buildData() {
        var data = [];
        var field = this.props.field;
        var spv = this.props.spv.projectionsByYear;
        var personal = this.props.personal.projectionsByYear;

        var spvTotal = 0;
        var personalTotal = 0;

        for (var i = 0; i < spv.length; i++) {

            spvTotal += spv[i][field];
            personalTotal += personal[i][field];

            var point = { year: spv[i]['year'], spv: spvTotal, personal: personalTotal };
            data.push(point);
        }

        return data;
    }

    render() {
        return (
            <ResponsiveContainer height={400} width="100%">

                <LineChart
                    data={this.buildData()}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="year" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    {this.props.target > 0 &&
                        <ReferenceLine y={this.props.profitGoal} label="Target" stroke="green" />
                    }
                    <Line type="monotone" dataKey="spv" name="Company held" stroke="#440099" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="personal" name="Personally held" stroke="#BD9B60" />
                </LineChart>
            </ResponsiveContainer>
        );
    }
}


const mapStateToProps = state => {
    return state.tax;
};


export default connect(mapStateToProps)(ChartLine);


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/Components/ChartLine.jsx